import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import BlogSeven from '../components/blog/BlogSeven';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const BlogStandardPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Blog Standard"
                currentPage="Blog Standard" 
            />
            <BlogSeven />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default BlogStandardPage;